import api from '.'

const AuthApi = {
	login: (token: string) => api.post('/login', { token }),
	logout: () => api.post('/logout'),
}

export default AuthApi
